import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { isDefaultLocale } from '../../../modules/i18n/locales';
import useCurrentSite from '../../../modules/react/hooks/useCurrentSite';
import useCurrentBuilderPage from '../../hooks/useCurrentBuilderPage';
import withReactRouter from '../../hocs/withReactRouter';
import ViewButton from '../ViewButton';
import styles from './styles.scss';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const ViewLiveButton = ({
  location: {
    pathname,
  },
}) => {
  const currentSite = useCurrentSite();
  const currentPage = useCurrentBuilderPage();

  const { isBlogEnabled } = currentSite;
  const { disableEnUsPage, live, loaded, loading, locale, path } = currentPage;

  const className = styles.button;
  let disabled;
  let href = '/';

  if (loading) {
    disabled = true;
  } else if (loaded) {
    disabled = !live || (disableEnUsPage && isDefaultLocale(locale));
    href = path;
  } else if (pathname.endsWith('/admin/blog')) {
    disabled = !isBlogEnabled;
    href = '/blog';
  }

  return (
    <ViewButton
      className={className}
      disabled={disabled}
      href={href}
    />
  );
};

ViewLiveButton.propTypes = propTypes;
ViewLiveButton.defaultProps = defaultProps;

ViewLiveButton.fragments = {
  contexts: {
    currentPage: gql`
    fragment ViewLiveButtonCurrentPage on Page {
      disableEnUsPage
      live
      locale
      path
    }
    `,
    currentSite: gql`
      fragment ViewLiveButtonCurrentSite on Site {
        isBlogEnabled
      }
    `,
  },
};

export default withReactRouter(ViewLiveButton);
